/**
 * IAN Assist — Ribbon function commands
 * Runs headless inside commands.html (no UI).
 */

/* global Office */

Office.onReady(() => {
  // Register function commands for ribbon buttons
});

/**
 * Quick summarize — fires from ribbon, shows notification toast.
 * @param {Office.AddinCommands.Event} event
 */
function quickSummarize(event) {
  const message = {
    type: Office.MailboxEnums.ItemNotificationMessageType.InformationalMessage,
    icon: "Icon.16x16",
    message: "IAN Assist: Open the taskpane to analyze this email.",
    persistent: false,
  };

  Office.context.mailbox.item.notificationMessages.replaceAsync("ianAction", message, () => {
    event.completed();
  });
}

// Associate command names declared in manifest
if (typeof Office.actions !== "undefined") {
  Office.actions.associate("quickSummarize", quickSummarize);
}
